import React, { useEffect, useState } from 'react';
import { getRefundReasons } from 'services';
import { showError, sortArray } from 'utils';

const ItemRefundReasonDropdown = props => {
  const [loading, setLoading] = useState<boolean>(false);
  const [reasons, setReasons] = useState<Record<string, any>[]>([]);
  const {
    value,
    onChange,
    isFull,
  } = props;
  
  const fetchReasons = async () => {
    setLoading(true);
    try {
      const reasons = await getRefundReasons();
      if (isFull) {
        setReasons(reasons.full);
      }else{
        setReasons(reasons.byItem);
      }
    } catch (e) {
      showError(e);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchReasons();
  }, []);
  
  const getOptions = () => sortArray(reasons, 'value').map((account, i) => (
    <option key={i} value={account.key}>{account.value}</option>),
  );

  return (
    <select
      value={value}
      disabled={loading}
      className={'form-control'}
      onChange={e => onChange(e.target.value)}
    >
      <option value='none' hidden={!!value}>Select a Reason</option>
      {reasons.length && getOptions()}
    </select>
  );
};

export default ItemRefundReasonDropdown;